import { render, staticRenderFns } from "./Merchantlist.vue?vue&type=template&id=18c7071e&scoped=true&"
import script from "./Merchantlist.vue?vue&type=script&lang=js&"
export * from "./Merchantlist.vue?vue&type=script&lang=js&"
import style0 from "./Merchantlist.vue?vue&type=style&index=0&id=18c7071e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7071e",
  null
  
)

export default component.exports